import NotFoundPage1 from "pages/notfound";
import "./App.css";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Suspense, lazy, useState } from "react";
import "pages/global.css";
import RootLayout from "pages/layout";
import Layout from "pages/(auth)/layout";
import AppLayout from "pages/(app)/layout";
import Loading from "pages/(app)/Loading";
import { usePathname, useRouter } from "components/Navigation";
import { GlobalProvider } from "./GlobalContext";
const Login = lazy(() => import("pages/(auth)/login/page"));
const ForgotPassword = lazy(() => import("pages/(auth)/forgot-password/page"));
const VerifyEmail = lazy(() => import("pages/(auth)/verify-email/page"));
const Akses = lazy(() => import("pages/(auth)/akses/page"));
const Dashboard = lazy(() => import("pages/(app)/dashboard/v1/page"));
const OldDashboard = lazy(() => import("pages/(app)/dashboard/page"));
import Callback from "./pages/Callback";
let PageDinamic = {};

PageDinamic["/dokumen/...slug"] = lazy(() =>
  import("pages/(app)/dokumen/[...slug]/page")
);
PageDinamic["/dokumen"] = lazy(() => import("pages/(app)/dokumen/page"));
PageDinamic["/group/...slug"] = lazy(() =>
  import("pages/(app)/group/[...slug]/page")
);
PageDinamic["/group"] = lazy(() => import("pages/(app)/group/page"));

PageDinamic["/internal_control_testing/id_register/...slug"] = lazy(() =>
  import("pages/(app)/internal_control_testing/[id_register]/[...slug]/page")
);
PageDinamic["/internal_control_testing/id_register"] = lazy(() =>
  import("pages/(app)/internal_control_testing/[id_register]/page")
);

PageDinamic["/risk_history/id_register/...slug"] = lazy(() =>
  import("pages/(app)/internal_control_testing/[id_register]/[...slug]/page")
);
PageDinamic["/risk_history/id_register"] = lazy(() =>
  import("pages/(app)/internal_control_testing/[id_register]/page")
);
// PageDinamic["/testing_risk_profile_new/id_register"] = lazy(() =>
//   import("pages/(app)/testing_risk_profile_new/[id_register]/page")
// );
// PageDinamic["/testing_risk_profile_new/id_register/...slug"] = lazy(() =>
//   import("pages/(app)/testing_risk_profile_new/[id_register]/[...slug]/page")
// );
PageDinamic["/laporan_bk_risiko"] = lazy(() =>
  import("pages/(app)/laporan_bk_risiko/page")
);
PageDinamic["/laporan_internal_control_testing"] = lazy(() =>
  import("pages/(app)/laporan_internal_control_testing/page")
);
PageDinamic["/laporan_loss_event"] = lazy(() =>
  import("pages/(app)/laporan_loss_event/page")
);
PageDinamic["/laporan_matrik_strategi_risiko"] = lazy(() =>
  import("pages/(app)/laporan_matrik_strategi_risiko/page")
);
PageDinamic["/laporan_sasaran_strategi_bisnis"] = lazy(() =>
  import("pages/(app)/laporan_sasaran_strategi_bisnis/page")
);
PageDinamic["/laporan_top_agregasi"] = lazy(() =>
  import("pages/(app)/laporan_top_agregasi/page")
);
PageDinamic["/laporan_top_risk"] = lazy(() =>
  import("pages/(app)/laporan_top_risk/page")
);
PageDinamic["/lost_event/id_register/...slug"] = lazy(() =>
  import("pages/(app)/lost_event/[id_register]/[...slug]/page")
);
PageDinamic["/lost_event/id_register"] = lazy(() =>
  import("pages/(app)/lost_event/[id_register]/page")
);
PageDinamic["/risk_ikhtisar/id_register/...slug"] = lazy(() =>
  import("pages/(app)/risk_ikhtisar/[id_register]/[...slug]/page")
);
PageDinamic["/risk_ikhtisar/id_register"] = lazy(() =>
  import("pages/(app)/risk_ikhtisar/[id_register]/page")
);
PageDinamic["/login_as"] = lazy(() => import("pages/(app)/login_as/page"));
PageDinamic["/matrix"] = lazy(() => import("pages/(app)/matrix/page"));
PageDinamic["/mt_assessment_type/...slug"] = lazy(() =>
  import("pages/(app)/mt_assessment_type/[...slug]/page")
);
PageDinamic["/mt_assessment_type"] = lazy(() =>
  import("pages/(app)/mt_assessment_type/page")
);
PageDinamic["/mt_risk_capacity_limit/...slug"] = lazy(() =>
  import("pages/(app)/mt_risk_capacity_limit/[...slug]/page")
);
PageDinamic["/mt_risk_capacity_limit"] = lazy(() =>
  import("pages/(app)/mt_risk_capacity_limit/page")
);
PageDinamic["/mt_risk_scope/...slug"] = lazy(() =>
  import("pages/(app)/mt_risk_scope/[...slug]/page")
);
PageDinamic["/mt_risk_scope"] = lazy(() =>
  import("pages/(app)/mt_risk_scope/page")
);
// PageDinamic["/risk_ikhtisar/...slug"] = lazy(() =>
//   import("pages/(app)/risk_ikhtisar/[...slug]/page")
// );
// PageDinamic["/risk_ikhtisar"] = lazy(() =>
//   import("pages/(app)/risk_ikhtisar/page")
// );
PageDinamic["/mt_jenis_data/...slug"] = lazy(() =>
  import("pages/(app)/mt_jenis_data/[...slug]/page")
);
PageDinamic["/mt_jenis_data"] = lazy(() =>
  import("pages/(app)/mt_jenis_data/page")
);
PageDinamic["/mt_kategori_dokumen/...slug"] = lazy(() =>
  import("pages/(app)/mt_kategori_dokumen/[...slug]/page")
);
PageDinamic["/mt_kategori_dokumen"] = lazy(() =>
  import("pages/(app)/mt_kategori_dokumen/page")
);
PageDinamic["/mt_lost_event_frakuensi_kejadian/...slug"] = lazy(() =>
  import("pages/(app)/mt_lost_event_frakuensi_kejadian/[...slug]/page")
);
PageDinamic["/mt_lost_event_frakuensi_kejadian"] = lazy(() =>
  import("pages/(app)/mt_lost_event_frakuensi_kejadian/page")
);
PageDinamic["/mt_lost_event_kategori/...slug"] = lazy(() =>
  import("pages/(app)/mt_lost_event_kategori/[...slug]/page")
);
PageDinamic["/mt_lost_event_kategori"] = lazy(() =>
  import("pages/(app)/mt_lost_event_kategori/page")
);
PageDinamic["/mt_lost_event_status_asuransi/...slug"] = lazy(() =>
  import("pages/(app)/mt_lost_event_status_asuransi/[...slug]/page")
);
PageDinamic["/mt_lost_event_status_asuransi"] = lazy(() =>
  import("pages/(app)/mt_lost_event_status_asuransi/page")
);
PageDinamic["/mt_lost_event_sumber/...slug"] = lazy(() =>
  import("pages/(app)/mt_lost_event_sumber/[...slug]/page")
);
PageDinamic["/mt_lost_event_sumber"] = lazy(() =>
  import("pages/(app)/mt_lost_event_sumber/page")
);
PageDinamic["/mt_lost_event_sumber_penyebab_kejadian/...slug"] = lazy(() =>
  import("pages/(app)/mt_lost_event_sumber_penyebab_kejadian/[...slug]/page")
);
PageDinamic["/mt_lost_event_sumber_penyebab_kejadian"] = lazy(() =>
  import("pages/(app)/mt_lost_event_sumber_penyebab_kejadian/page")
);
PageDinamic["/mt_risk_agregasi_kelompok_bisnis/...slug"] = lazy(() =>
  import("pages/(app)/mt_risk_agregasi_kelompok_bisnis/[...slug]/page")
);
PageDinamic["/mt_risk_agregasi_kelompok_bisnis"] = lazy(() =>
  import("pages/(app)/mt_risk_agregasi_kelompok_bisnis/page")
);
PageDinamic["/mt_risk_agregasi_risiko/...slug"] = lazy(() =>
  import("pages/(app)/mt_risk_agregasi_risiko/[...slug]/page")
);
PageDinamic["/mt_risk_agregasi_risiko"] = lazy(() =>
  import("pages/(app)/mt_risk_agregasi_risiko/page")
);
PageDinamic["/mt_risk_agregasi_risiko_sasaran/...slug"] = lazy(() =>
  import("pages/(app)/mt_risk_agregasi_risiko_sasaran/[...slug]/page")
);
PageDinamic["/mt_risk_agregasi_risiko_sasaran"] = lazy(() =>
  import("pages/(app)/mt_risk_agregasi_risiko_sasaran/page")
);
PageDinamic["/mt_risk_dampak/...slug"] = lazy(() =>
  import("pages/(app)/mt_risk_dampak/[...slug]/page")
);
PageDinamic["/mt_risk_dampak"] = lazy(() =>
  import("pages/(app)/mt_risk_dampak/page")
);
PageDinamic["/mt_risk_efektifitas_control/...slug"] = lazy(() =>
  import("pages/(app)/mt_risk_efektifitas_control/[...slug]/page")
);
PageDinamic["/mt_risk_efektifitas_control"] = lazy(() =>
  import("pages/(app)/mt_risk_efektifitas_control/page")
);
PageDinamic["/mt_risk_jenis_control/...slug"] = lazy(() =>
  import("pages/(app)/mt_risk_jenis_control/[...slug]/page")
);
PageDinamic["/mt_risk_jenis_control"] = lazy(() =>
  import("pages/(app)/mt_risk_jenis_control/page")
);
PageDinamic["/mt_risk_jenis_perlakuan/...slug"] = lazy(() =>
  import("pages/(app)/mt_risk_jenis_perlakuan/[...slug]/page")
);
PageDinamic["/mt_risk_jenis_perlakuan"] = lazy(() =>
  import("pages/(app)/mt_risk_jenis_perlakuan/page")
);
PageDinamic["/mt_risk_jenis_program_rkap/...slug"] = lazy(() =>
  import("pages/(app)/mt_risk_jenis_program_rkap/[...slug]/page")
);
PageDinamic["/mt_risk_jenis_program_rkap"] = lazy(() =>
  import("pages/(app)/mt_risk_jenis_program_rkap/page")
);
PageDinamic["/mt_risk_jenis_risiko/...slug"] = lazy(() =>
  import("pages/(app)/mt_risk_jenis_risiko/[...slug]/page")
);
PageDinamic["/mt_risk_jenis_risiko"] = lazy(() =>
  import("pages/(app)/mt_risk_jenis_risiko/page")
);
PageDinamic["/mt_risk_kategori_risiko/...slug"] = lazy(() =>
  import("pages/(app)/mt_risk_kategori_risiko/[...slug]/page")
);
PageDinamic["/mt_risk_kategori_risiko"] = lazy(() =>
  import("pages/(app)/mt_risk_kategori_risiko/page")
);
PageDinamic["/mt_risk_kemungkinan/...slug"] = lazy(() =>
  import("pages/(app)/mt_risk_kemungkinan/[...slug]/page")
);
PageDinamic["/mt_risk_kemungkinan"] = lazy(() =>
  import("pages/(app)/mt_risk_kemungkinan/page")
);
PageDinamic["/mt_risk_kriteria_dampak/...slug"] = lazy(() =>
  import("pages/(app)/mt_risk_kriteria_dampak/[...slug]/page")
);
PageDinamic["/mt_risk_kriteria_dampak/jenis"] = lazy(() =>
  import("pages/(app)/mt_risk_kriteria_dampak/[jenis]/page")
);
PageDinamic["/mt_risk_kriteria_dampak_detail/...slug"] = lazy(() =>
  import("pages/(app)/mt_risk_kriteria_dampak_detail/[...slug]/page")
);
PageDinamic["/mt_risk_kriteria_dampak_detail"] = lazy(() =>
  import("pages/(app)/mt_risk_kriteria_dampak_detail/page")
);
PageDinamic["/mt_risk_matrix/jenis/...slug"] = lazy(() =>
  import("pages/(app)/mt_risk_matrix/[jenis]/[...slug]/page")
);
PageDinamic["/mt_risk_matrix/jenis"] = lazy(() =>
  import("pages/(app)/mt_risk_matrix/[jenis]/page")
);
PageDinamic["/mt_risk_perlakuan/...slug"] = lazy(() =>
  import("pages/(app)/mt_risk_perlakuan/[...slug]/page")
);
PageDinamic["/mt_risk_perlakuan"] = lazy(() =>
  import("pages/(app)/mt_risk_perlakuan/page")
);
PageDinamic["/mt_risk_sasaran/...slug"] = lazy(() =>
  import("pages/(app)/mt_risk_sasaran/[...slug]/page")
);
PageDinamic["/mt_risk_sasaran"] = lazy(() =>
  import("pages/(app)/mt_risk_sasaran/page")
);
PageDinamic["/mt_risk_sikap_terhadap_risiko/...slug"] = lazy(() =>
  import("pages/(app)/mt_risk_sikap_terhadap_risiko/[...slug]/page")
);
PageDinamic["/mt_risk_sikap_terhadap_risiko"] = lazy(() =>
  import("pages/(app)/mt_risk_sikap_terhadap_risiko/page")
);
PageDinamic["/mt_risk_taksonomi/...slug"] = lazy(() =>
  import("pages/(app)/mt_risk_taksonomi/[...slug]/page")
);
PageDinamic["/mt_risk_taksonomi"] = lazy(() =>
  import("pages/(app)/mt_risk_taksonomi/page")
);
PageDinamic["/mt_risk_taksonomi_area/...slug"] = lazy(() =>
  import("pages/(app)/mt_risk_taksonomi_area/[...slug]/page")
);
PageDinamic["/mt_risk_taksonomi_area"] = lazy(() =>
  import("pages/(app)/mt_risk_taksonomi_area/page")
);
PageDinamic["/mt_risk_taksonomi_objective/...slug"] = lazy(() =>
  import("pages/(app)/mt_risk_taksonomi_objective/[...slug]/page")
);
PageDinamic["/mt_risk_taksonomi_objective"] = lazy(() =>
  import("pages/(app)/mt_risk_taksonomi_objective/page")
);
PageDinamic["/mt_risk_tingkat/...slug"] = lazy(() =>
  import("pages/(app)/mt_risk_tingkat/[...slug]/page")
);
PageDinamic["/mt_risk_tingkat"] = lazy(() =>
  import("pages/(app)/mt_risk_tingkat/page")
);
PageDinamic["/mt_risk_tingkat_agregasi_risiko/...slug"] = lazy(() =>
  import("pages/(app)/mt_risk_tingkat_agregasi_risiko/[...slug]/page")
);
PageDinamic["/mt_risk_tingkat_agregasi_risiko"] = lazy(() =>
  import("pages/(app)/mt_risk_tingkat_agregasi_risiko/page")
);
PageDinamic["/mt_risk_tingkat_agregasi_risiko copy/...slug"] = lazy(() =>
  import("pages/(app)/mt_risk_tingkat_agregasi_risiko copy/[...slug]/page")
);
PageDinamic["/mt_risk_tingkat_agregasi_risiko copy"] = lazy(() =>
  import("pages/(app)/mt_risk_tingkat_agregasi_risiko copy/page")
);
PageDinamic["/mt_sdm_jabatan/...slug"] = lazy(() =>
  import("pages/(app)/mt_sdm_jabatan/[...slug]/page")
);
PageDinamic["/mt_sdm_jabatan"] = lazy(() =>
  import("pages/(app)/mt_sdm_jabatan/page")
);
PageDinamic["/mt_sdm_jabatan copy/...slug"] = lazy(() =>
  import("pages/(app)/mt_sdm_jabatan copy/[...slug]/page")
);
PageDinamic["/mt_sdm_jabatan copy"] = lazy(() =>
  import("pages/(app)/mt_sdm_jabatan copy/page")
);
PageDinamic["/mt_sdm_kelompok_bisnis/...slug"] = lazy(() =>
  import("pages/(app)/mt_sdm_kelompok_bisnis/[...slug]/page")
);
PageDinamic["/mt_sdm_kelompok_bisnis"] = lazy(() =>
  import("pages/(app)/mt_sdm_kelompok_bisnis/page")
);
PageDinamic["/mt_sdm_pegawai/...slug"] = lazy(() =>
  import("pages/(app)/mt_sdm_pegawai/[...slug]/page")
);
PageDinamic["/mt_sdm_pegawai"] = lazy(() =>
  import("pages/(app)/mt_sdm_pegawai/page")
);
PageDinamic["/mt_sdm_unit/...slug"] = lazy(() =>
  import("pages/(app)/mt_sdm_unit/[...slug]/page")
);
PageDinamic["/mt_sdm_unit"] = lazy(() =>
  import("pages/(app)/mt_sdm_unit/page")
);
PageDinamic["/mt_status_pengajuan/...slug"] = lazy(() =>
  import("pages/(app)/mt_status_pengajuan/[...slug]/page")
);
PageDinamic["/mt_status_pengajuan"] = lazy(() =>
  import("pages/(app)/mt_status_pengajuan/page")
);
PageDinamic["/mt_status_pengajuan_page_disable/...slug"] = lazy(() =>
  import("pages/(app)/mt_status_pengajuan_page_disable/[...slug]/page")
);
PageDinamic["/mt_status_pengajuan_page_disable"] = lazy(() =>
  import("pages/(app)/mt_status_pengajuan_page_disable/page")
);
PageDinamic["/mt_status_pengajuan_penerima/...slug"] = lazy(() =>
  import("pages/(app)/mt_status_pengajuan_penerima/[...slug]/page")
);
PageDinamic["/mt_status_pengajuan_penerima"] = lazy(() =>
  import("pages/(app)/mt_status_pengajuan_penerima/page")
);
PageDinamic["/mt_status_pengajuan_read_only/...slug"] = lazy(() =>
  import("pages/(app)/mt_status_pengajuan_read_only/[...slug]/page")
);
PageDinamic["/mt_status_pengajuan_read_only"] = lazy(() =>
  import("pages/(app)/mt_status_pengajuan_read_only/page")
);
PageDinamic["/mt_risk_profile_approval_matrix/...slug"] = lazy(() =>
  import("pages/(app)/mt_risk_profile_approval_matrix/[...slug]/page")
);
PageDinamic["/mt_risk_profile_approval_matrix"] = lazy(() =>
  import("pages/(app)/mt_risk_profile_approval_matrix/page")
);
PageDinamic["/mt_status_rencana_perlakuan/...slug"] = lazy(() =>
  import("pages/(app)/mt_status_rencana_perlakuan/[...slug]/page")
);
PageDinamic["/mt_status_rencana_perlakuan"] = lazy(() =>
  import("pages/(app)/mt_status_rencana_perlakuan/page")
);
PageDinamic["/mt_prespektif/...slug"] = lazy(() =>
  import("pages/(app)/mt_prespektif/[...slug]/page")
);
PageDinamic["/mt_prespektif"] = lazy(() =>
  import("pages/(app)/mt_prespektif/page")
);
PageDinamic["/mt_sasaran/...slug"] = lazy(() =>
  import("pages/(app)/mt_sasaran/[...slug]/page")
);
PageDinamic["/mt_sasaran"] = lazy(() => import("pages/(app)/mt_sasaran/page"));
PageDinamic["/kpi/...slug"] = lazy(() =>
  import("pages/(app)/kpi/[...slug]/page")
);
PageDinamic["/kpi"] = lazy(() => import("pages/(app)/kpi/page"));
// PageDinamic["/mt_tamplate_laporan/...slug"] = lazy(() =>
//   import("pages/(app)/mt_tamplate_laporan/[...slug]/page")
// );
// PageDinamic["/mt_tamplate_laporan"] = lazy(() =>
//   import("pages/(app)/mt_tamplate_laporan/page")
// );
// PageDinamic["/mt_template_laporan/...slug"] = lazy(() =>
//   import("pages/(app)/mt_template_laporan/[...slug]/page")
// );
// PageDinamic["/mt_template_laporan"] = lazy(() =>
//   import("pages/(app)/mt_template_laporan/page")
// );
PageDinamic["/progress_efektifitas"] = lazy(() =>
  import("pages/(app)/progress_efektifitas/page")
);
PageDinamic["/profile"] = lazy(() => import("pages/(app)/profile/page"));
PageDinamic["/profile/...slug"] = lazy(() =>
  import("pages/(app)/profile/[...slug]/page")
);
PageDinamic["/report"] = lazy(() => import("pages/(app)/report/page"));
PageDinamic["/risk_capacity_limit/id_register/...slug"] = lazy(() =>
  import("pages/(app)/risk_capacity_limit/[id_register]/[...slug]/page")
);
PageDinamic["/risk_capacity_limit/id_register"] = lazy(() =>
  import("pages/(app)/risk_capacity_limit/[id_register]/page")
);
PageDinamic["/risk_capacity_risk_appetie"] = lazy(() =>
  import("pages/(app)/risk_capacity_risk_appetie/page")
);
PageDinamic["/risk_dampak/...slug"] = lazy(() =>
  import("pages/(app)/risk_dampak/[...slug]/page")
);
PageDinamic["/risk_dampak"] = lazy(() =>
  import("pages/(app)/risk_dampak/page")
);
PageDinamic["/risk_task"] = lazy(() => import("pages/(app)/risk_task/page"));
PageDinamic["/risk_library"] = lazy(() =>
  import("pages/(app)/risk_library/page")
);
PageDinamic["/risk_metrik_strategi_risiko/id_register/...slug"] = lazy(() =>
  import("pages/(app)/risk_metrik_strategi_risiko/[id_register]/[...slug]/page")
);
PageDinamic["/risk_metrik_strategi_risiko/id_register"] = lazy(() =>
  import("pages/(app)/risk_metrik_strategi_risiko/[id_register]/page")
);
PageDinamic["/risk_msg/...slug"] = lazy(() =>
  import("pages/(app)/risk_msg/[...slug]/page")
);
PageDinamic["/risk_msg"] = lazy(() => import("pages/(app)/risk_msg/page"));
PageDinamic["/risk_msg_penerima/...slug"] = lazy(() =>
  import("pages/(app)/risk_msg_penerima/[...slug]/page")
);
PageDinamic["/risk_msg_penerima"] = lazy(() =>
  import("pages/(app)/risk_msg_penerima/page")
);
PageDinamic["/risk_penyebab/...slug"] = lazy(() =>
  import("pages/(app)/risk_penyebab/[...slug]/page")
);
PageDinamic["/risk_penyebab"] = lazy(() =>
  import("pages/(app)/risk_penyebab/page")
);
PageDinamic["/risk_profile/id_register/...slug"] = lazy(() =>
  import("pages/(app)/risk_profile/[id_register]/[...slug]/page")
);
PageDinamic["/risk_profile/id_register"] = lazy(() =>
  import("pages/(app)/risk_profile/[id_register]/page")
);
PageDinamic["/risk_profile_analisa_risiko_inheren/id_register/...slug"] = lazy(
  () =>
    import(
      "pages/(app)/risk_profile_analisa_risiko_inheren/[id_register]/[...slug]/page"
    )
);
PageDinamic["/risk_profile_analisa_risiko_inheren/id_register"] = lazy(() =>
  import("pages/(app)/risk_profile_analisa_risiko_inheren/[id_register]/page")
);
PageDinamic["/risk_profile_analisa_risiko_residual/id_register/...slug"] = lazy(
  () =>
    import(
      "pages/(app)/risk_profile_analisa_risiko_residual/[id_register]/[...slug]/page"
    )
);
PageDinamic["/risk_profile_analisa_risiko_residual/id_register"] = lazy(() =>
  import("pages/(app)/risk_profile_analisa_risiko_residual/[id_register]/page")
);
PageDinamic["/risk_profile_analisis/id_register/...slug"] = lazy(() =>
  import("pages/(app)/risk_profile_analisis/[id_register]/[...slug]/page")
);
PageDinamic["/risk_profile_control/...slug"] = lazy(() =>
  import("pages/(app)/risk_profile_control/[...slug]/page")
);
PageDinamic["/risk_profile_control"] = lazy(() =>
  import("pages/(app)/risk_profile_control/page")
);
PageDinamic["/risk_profile_dampak/...slug"] = lazy(() =>
  import("pages/(app)/risk_profile_dampak/[...slug]/page")
);
PageDinamic["/risk_profile_dampak"] = lazy(() =>
  import("pages/(app)/risk_profile_dampak/page")
);
PageDinamic["/risk_profile_detail"] = lazy(() =>
  import("pages/(app)/risk_profile_detail/page")
);
PageDinamic["/risk_profile_kri/...slug"] = lazy(() =>
  import("pages/(app)/risk_profile_kri/[...slug]/page")
);
PageDinamic["/risk_profile_kri"] = lazy(() =>
  import("pages/(app)/risk_profile_kri/page")
);
PageDinamic["/risk_profile_kri_hasil/...slug"] = lazy(() =>
  import("pages/(app)/risk_profile_kri_hasil/[...slug]/page")
);
PageDinamic["/risk_profile_kri_hasil"] = lazy(() =>
  import("pages/(app)/risk_profile_kri_hasil/page")
);
PageDinamic["/risk_profile_mitigasi/...slug"] = lazy(() =>
  import("pages/(app)/risk_profile_mitigasi/[...slug]/page")
);
PageDinamic["/risk_profile_mitigasi"] = lazy(() =>
  import("pages/(app)/risk_profile_mitigasi/page")
);
PageDinamic["/risk_profile_mitigasi_jenis/...slug"] = lazy(() =>
  import("pages/(app)/risk_profile_mitigasi_jenis/[...slug]/page")
);
PageDinamic["/risk_profile_mitigasi_jenis"] = lazy(() =>
  import("pages/(app)/risk_profile_mitigasi_jenis/page")
);
PageDinamic["/risk_profile_mitigasi_realisasi/...slug"] = lazy(() =>
  import("pages/(app)/risk_profile_mitigasi_realisasi/[...slug]/page")
);
PageDinamic["/risk_profile_mitigasi_realisasi"] = lazy(() =>
  import("pages/(app)/risk_profile_mitigasi_realisasi/page")
);
PageDinamic["/risk_profile_penyebab/...slug"] = lazy(() =>
  import("pages/(app)/risk_profile_penyebab/[...slug]/page")
);
PageDinamic["/risk_profile_penyebab"] = lazy(() =>
  import("pages/(app)/risk_profile_penyebab/page")
);
PageDinamic[
  "/risk_profile_realisasi_pelaksanaan_perlakuan_risiko_dan_biaya/id_register/...slug"
] = lazy(() =>
  import(
    "pages/(app)/risk_profile_realisasi_pelaksanaan_perlakuan_risiko_dan_biaya/[id_register]/[...slug]/page"
  )
);
PageDinamic[
  "/risk_profile_realisasi_pelaksanaan_perlakuan_risiko_dan_biaya/id_register"
] = lazy(() =>
  import(
    "pages/(app)/risk_profile_realisasi_pelaksanaan_perlakuan_risiko_dan_biaya/[id_register]/page"
  )
);
PageDinamic["/risk_profile_realisasi_residual/...slug"] = lazy(() =>
  import("pages/(app)/risk_profile_realisasi_residual/[...slug]/page")
);
PageDinamic["/risk_profile_realisasi_residual"] = lazy(() =>
  import("pages/(app)/risk_profile_realisasi_residual/page")
);

PageDinamic["/risk_profile_realisasi_risiko_residual/id_register/...slug"] =
  lazy(() =>
    import(
      "pages/(app)/risk_profile_realisasi_risiko_residual/[id_register]/[...slug]/page"
    )
  );
PageDinamic["/risk_profile_realisasi_risiko_residual/id_register"] = lazy(() =>
  import(
    "pages/(app)/risk_profile_realisasi_risiko_residual/[id_register]/page"
  )
);
PageDinamic["/risk_profile_real_risiko/id_register/...slug"] = lazy(() =>
  import("pages/(app)/risk_profile_real_risiko/[id_register]/[...slug]/page")
);
PageDinamic["/risk_profile_real_risiko/id_register"] = lazy(() =>
  import("pages/(app)/risk_profile_real_risiko/[id_register]/page")
);
PageDinamic["/risk_profile_rencana_perlakuan_risiko/id_register/...slug"] =
  lazy(() =>
    import(
      "pages/(app)/risk_profile_rencana_perlakuan_risiko/[id_register]/[...slug]/page"
    )
  );
PageDinamic["/risk_profile_rencana_perlakuan_risiko/id_register"] = lazy(() =>
  import("pages/(app)/risk_profile_rencana_perlakuan_risiko/[id_register]/page")
);
PageDinamic["/risk_profile_target_residual/...slug"] = lazy(() =>
  import("pages/(app)/risk_profile_target_residual/[...slug]/page")
);
PageDinamic["/risk_profile_target_residual"] = lazy(() =>
  import("pages/(app)/risk_profile_target_residual/page")
);
PageDinamic["/risk_register/...slug"] = lazy(() =>
  import("pages/(app)/risk_register/[...slug]/page")
);
PageDinamic["/risk_register"] = lazy(() =>
  import("pages/(app)/risk_register/page")
);
PageDinamic["/risk_register_rtp"] = lazy(() =>
  import("pages/(app)/risk_register_rtp/page")
);
PageDinamic["/monitoring_kri"] = lazy(() =>
  import("pages/(app)/monitoring_kri/page")
);
PageDinamic["/monitoring_risk_event"] = lazy(() =>
  import("pages/(app)/monitoring_risk_event/page")
);
PageDinamic["/monitoring_rtp"] = lazy(() =>
  import("pages/(app)/monitoring_rtp/page")
);
PageDinamic["/risk_risiko/...slug"] = lazy(() =>
  import("pages/(app)/risk_risiko/[...slug]/page")
);
PageDinamic["/risk_risiko"] = lazy(() =>
  import("pages/(app)/risk_risiko/page")
);
PageDinamic["/user_guide"] = lazy(() => import("pages/(app)/user_guide/page"));
PageDinamic["/risk_sasaran/id_register/...slug"] = lazy(() =>
  import("pages/(app)/risk_sasaran/[id_register]/[...slug]/page")
);
PageDinamic["/risk_sasaran/id_register"] = lazy(() =>
  import("pages/(app)/risk_sasaran/[id_register]/page")
);
PageDinamic["/risk_sasaran_strategi/...slug"] = lazy(() =>
  import("pages/(app)/risk_sasaran_strategi/[...slug]/page")
);
PageDinamic["/risk_sasaran_strategi"] = lazy(() =>
  import("pages/(app)/risk_sasaran_strategi/page")
);
PageDinamic["/risk_visi_misi"] = lazy(() =>
  import("pages/(app)/risk_visi_misi/page")
);
PageDinamic["/sasaran"] = lazy(() => import("pages/(app)/sasaran/page"));
PageDinamic["/sebaran_risiko"] = lazy(() =>
  import("pages/(app)/sebaran_risiko/page")
);
PageDinamic["/project_risk_level"] = lazy(() =>
  import("pages/(app)/project_risk_level/page")
);
PageDinamic["/search"] = lazy(() =>
  import("pages/(app)/search/[keyword]/page")
);
PageDinamic["/search/keyword"] = lazy(() =>
  import("pages/(app)/search/[keyword]/page")
);
PageDinamic["/sys_log/...slug"] = lazy(() =>
  import("pages/(app)/sys_log/[...slug]/page")
);
PageDinamic["/sys_log"] = lazy(() => import("pages/(app)/sys_log/page"));
PageDinamic["/sys_menu/...slug"] = lazy(() =>
  import("pages/(app)/sys_menu/[...slug]/page")
);
PageDinamic["/sys_menu"] = lazy(() => import("pages/(app)/sys_menu/page"));
PageDinamic["/sys_setting/...slug"] = lazy(() =>
  import("pages/(app)/sys_setting/[...slug]/page")
);
PageDinamic["/sys_setting"] = lazy(() =>
  import("pages/(app)/sys_setting/page")
);
PageDinamic["/sys_user/...slug"] = lazy(() =>
  import("pages/(app)/sys_user/[...slug]/page")
);
PageDinamic["/sys_user"] = lazy(() => import("pages/(app)/sys_user/page"));
PageDinamic["/sys_user_group/...slug"] = lazy(() =>
  import("pages/(app)/sys_user_group/[...slug]/page")
);
PageDinamic["/sys_user_group"] = lazy(() =>
  import("pages/(app)/sys_user_group/page")
);
PageDinamic["/risk_jadwal_pelaporan/...slug"] = lazy(() =>
  import("pages/(app)/risk_jadwal_pelaporan/[...slug]/page")
);
PageDinamic["/risk_jadwal_pelaporan"] = lazy(() =>
  import("pages/(app)/risk_jadwal_pelaporan/page")
);

PageDinamic["/reques_fitur/...slug"] = lazy(() =>
  import("pages/(app)/public_reques_fitur/[...slug]/page")
);
PageDinamic["/reques_fitur"] = lazy(() =>
  import("pages/(app)/public_reques_fitur/page")
);

// PageDinamic["/pelaporan_unit_kerja/...slug"] = lazy(() =>
//   import("pages/(app)/pelaporan_unit_kerja/[...slug]/page")
// );
PageDinamic["/pelaporan_unit_kerja"] = lazy(() =>
  import("pages/(app)/pelaporan_unit_kerja/page")
);

PageDinamic["/kriteria_kemungkinan/...slug"] = lazy(() =>
  import("pages/(app)/mt_risk_kriteria_kemungkinan/[...slug]/page")
);
PageDinamic["/kriteria_kemungkinan/jenis"] = lazy(() =>
  import("pages/(app)/mt_risk_kriteria_kemungkinan/[jenis]/page")
);

PageDinamic["/mt_penerapan/...slug"] = lazy(() =>
  import("pages/(app)/mt_penerapan/[...slug]/page")
);
PageDinamic["/mt_penerapan"] = lazy(() =>
  import("pages/(app)/mt_penerapan/page")
);

PageDinamic["/mt_kelayakan/...slug"] = lazy(() =>
  import("pages/(app)/mt_kelayakan/[...slug]/page")
);
PageDinamic["/mt_kelayakan"] = lazy(() =>
  import("pages/(app)/mt_kelayakan/page")
);

PageDinamic["/mt_kelayakan_penerapan/...slug"] = lazy(() =>
  import("pages/(app)/mt_kelayakan_penerapan/[...slug]/page")
);
PageDinamic["/mt_kelayakan_penerapan"] = lazy(() =>
  import("pages/(app)/mt_kelayakan_penerapan/page")
);

PageDinamic["/mt_referensi_kontrol_smki/...slug"] = lazy(() =>
  import("pages/(app)/mt_referensi_kontrol_smki/[...slug]/page")
);
PageDinamic["/mt_referensi_kontrol_smki"] = lazy(() =>
  import("pages/(app)/mt_referensi_kontrol_smki/page")
);

// const tryRequirelayout = (path) => {
//   if (path == null) {
//     return null;
//   }
//   path1 = path + "/layout";
//   try {
//     return require(`${path1}`);
//   } catch (err) {
//     path2 = path.split("/");
//     path2.pop();
//     return tryRequirelayout(path2.join("/"));
//   }
// };

function App() {
  const [master, set_master] = useState(false);
  let params = {};
  let pathnameimport = useLocation().pathname;
  let pathname = pathnameimport;

  let pathnamearr = pathnameimport.split("/");
  if (pathnamearr.length > 2) {
    let keyarr = Object.keys(PageDinamic).filter((str) => {
      let sstr = str.split("/");
      let spth = pathname.split("/");
      if (spth[1] == sstr[1]) return true;
    });
    // console.log(keyarr);
    if (keyarr.length) {
      let key = keyarr[0].split("/")[2];
      // console.log(keyarr[1]);
      if (key == "...slug" && keyarr[1]) key = keyarr[1].split("/")[2];

      if (key !== "...slug") {
        let pathidregister = "/" + pathnamearr[1] + "/" + key;
        // // console.log("key")
        // // console.log(key)
        if (PageDinamic[pathidregister]) {
          params[key] = pathnamearr[2];
          pathnameimport = pathidregister;
          let i = 3;
          while (pathnamearr[i]) {
            pathnameimport += "/" + pathnamearr[i];
            i++;
          }
        }
      }
    }
  }

  // // console.log("APP");
  pathnameimport = pathnameimport
    .replace("/add", "/...slug/add")
    .replace("/edit", "/...slug/edit")
    .replace("/detail", "/...slug/detail");
  const paramarr = pathnameimport.split("/...slug/");
  if (paramarr[1]) {
    params.slug = paramarr[1].split("/");
    if (params.slug) pathnameimport = paramarr[0] + "/...slug";
  }

  let PageComponen = PageDinamic[pathnameimport];
  // // console.log('PageComponen')
  // // console.log(pathnameimport)
  // // console.log(PageComponen)
  if (
    !PageComponen &&
    pathnameimport == "/mt_risk_kriteria_dampak/jenis/...slug"
  ) {
    PageComponen = PageDinamic["/mt_risk_kriteria_dampak/...slug"];
  }
  if (
    !PageComponen &&
    pathnameimport == "/setup_master_mt_risk_kriteria_dampak/jenis/...slug"
  ) {
    PageComponen = PageDinamic["/setup_master_mt_risk_kriteria_dampak/...slug"];
  }
  if (
    !PageComponen &&
    pathnameimport == "/kriteria_kemungkinan/jenis/...slug"
  ) {
    PageComponen = PageDinamic["/kriteria_kemungkinan/...slug"];
  }

  // let LayoutComponen = tryRequirelayout();
  const router = useRouter();
  const pathname_param = usePathname();
  const pathname_param_arr = pathname_param.split("/");
  const addprops = {
    // router, pathname: pathname_param, pathaccess: paramarr[0].substring(1)
    router,
    pathname: pathname_param,
    pathaccess: pathname_param_arr[1].includes("setup_master")
      ? pathname_param_arr[1].replace("setup_master_", "")
      : pathname_param_arr[1],
  };

  console.log("APPPPPP====>");

  console.log(pathname);
  console.log(pathnameimport);
  console.log(PageComponen);
  console.log(addprops);
  console.log(params);

  if (pathname)
    return (
      <GlobalProvider>
        <RootLayout>
          <Suspense fallback={<Loading />}>
            <Routes>
              <Route
                path="/login"
                element={
                  <Layout {...addprops}>
                    <Login />
                  </Layout>
                }
              />

              <Route
                path="/forgot-password"
                element={
                  <Layout {...addprops}>
                    <ForgotPassword />
                  </Layout>
                }
              />
              {/* <Route
              path="/verification"
              element={
                <Layout {...addprops}>
                  <VerifyEmail />
                </Layout>
              }
            /> */}
              <Route
                path="/akses"
                element={
                  <Layout {...addprops}>
                    <Akses {...addprops} />
                  </Layout>
                }
              />
              <Route
                path="/dashboard"
                element={
                  <AppLayout {...addprops}>
                    <Dashboard {...addprops} />
                  </AppLayout>
                }
              />
              <Route
                path="/dashboard/old"
                element={
                  <AppLayout {...addprops}>
                    <OldDashboard {...addprops} />
                  </AppLayout>
                }
              />
              <Route
                path="/dashboard/v1"
                element={<Navigate to="/dashboard" replace />}
              />
              <Route
                path="/"
                element={
                  <AppLayout {...addprops}>
                    <Dashboard {...addprops} />
                  </AppLayout>
                }
              />

              {PageComponen ? (
                <Route
                  path={pathname}
                  element={
                    <AppLayout {...addprops}>
                      <PageComponen params={params} {...addprops} />
                    </AppLayout>
                  }
                />
              ) : null}
              <Route path="*" element={<NotFoundPage1 />} />
              <Route path="/not-found" element={<NotFoundPage1 />} />
              <Route path="/callback" element={<Callback />} />
            </Routes>
          </Suspense>
        </RootLayout>
      </GlobalProvider>
    );
}

export default App;

export { PageDinamic };
